import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

let swiperInstance: Swiper | null = null;

export const initMarket = (): void => {
  // Clear any existing ScrollTriggers to prevent duplicate instances during Vite HMR
  ScrollTrigger.getAll().forEach(trigger => {
    if (trigger.trigger && ((trigger.trigger as HTMLElement).id === 'como-funciona' || (trigger.trigger as HTMLElement).id === 'para-quien')) {
      trigger.kill();
    }
  });

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 1. Adaptive Swiper logic for mobile
  const handleSwiper = (): void => {
    const swiperEl = document.querySelector('.market-swiper');
    if (!swiperEl) return;

    const isMobile = window.innerWidth < 768;

    if (isMobile) {
      if (!swiperInstance) {
        swiperInstance = new Swiper('.market-swiper', {
          modules: [Pagination, Autoplay],
          slidesPerView: 1.2,
          spaceBetween: 16,
          centeredSlides: true,
          loop: !prefersReducedMotion,
          autoplay: prefersReducedMotion ? false : {
            delay: 3500,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  };

  // 2. GSAP ScrollTrigger Animations
  
  // Section: Cómo Funciona (Features reveal)
  const howItWorksSection = document.getElementById('como-funciona');
  if (howItWorksSection) {
    const features = howItWorksSection.querySelectorAll('.reveal-feature');
    if (features.length > 0) {
      gsap.from(features, {
        scrollTrigger: {
          trigger: howItWorksSection,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        x: prefersReducedMotion ? 0 : 30, // slide in from right/left
        duration: prefersReducedMotion ? 0 : 0.8,
        stagger: prefersReducedMotion ? 0 : 0.15,
        ease: 'power2.out',
      });
    }
  }

  // Section: Para Quién Es (Stagger reveal for cards in desktop)
  const paraQuienSection = document.getElementById('para-quien');
  if (paraQuienSection) {
    const slides = paraQuienSection.querySelectorAll('.market-story');
    if (slides.length > 0) {
      gsap.from(slides, {
        scrollTrigger: {
          trigger: paraQuienSection,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
        opacity: 0,
        y: prefersReducedMotion ? 0 : 30,
        duration: prefersReducedMotion ? 0 : 0.8,
        stagger: prefersReducedMotion ? 0 : 0.1,
        ease: 'power2.out',
      });
    }
  }

  // Initialize and listen to resize events
  handleSwiper();
  window.addEventListener('resize', handleSwiper);
};
